// extracted by mini-css-extract-plugin
export default {"addToCartControl":"p0-z","giftCard":"q0-z","btnContainer":"r0-z","cartButton":"s0-z","disabled":"t0-z"};